import React, { useEffect, useMemo, useRef, useState } from "react"
import { Link } from "react-router-dom"
import { isEmpty } from "lodash"
import "../../../../node_modules/bootstrap/dist/css/bootstrap.min.css"
import TableContainer from "../../../components/Common/TableContainer"
import TableGrid from "../../../components/Common/TableGrid"
import "@formatjs/intl-numberformat/polyfill"
import toastr from "toastr"
//import components
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import DeleteModal from "../../../components/Common/DeleteModal"
import ConfirmModal from "../../../components/Common/ConfirmModal"
import EditLoteModal from "./EditLoteModal"
import CargaModal from "./CargaModal"
// import ConfigApp from "../../../helpers/config_helper";

import {
  getPublicacoesPendentes as onGetPublicacoesPendentes,
  updateProcesso as onUpdateProcesso,
  updatePublicacao as onUpdatePublicacao,
  resetProccessMessages,
} from "store/actions"

// import { storePublicacao } from "store/leads/publicacao";

import {
  PublicNo,
  PublicTags,
  PoloPassivo,
  PublicValor,
  PublicDate,
  Prioridade,
  PublicStatus,
  LeadStatus,
} from "./QualificacaoListCol"

//redux
import { useSelector, useDispatch } from "react-redux"

import {
  Col,
  Row,
  Card,
  CardBody,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Tooltip,
} from "reactstrap"
import ModalAddProcesso from "./ModalAddProcesso"
import StatusMap from "helpers/statusMap"
//import contactsProfile from "pages/Contacts/ContactsProfile/contacts-profile";
// import TableGrid from "components/Common/TableGrid";

function QualificacaoList() {
  //meta title
  document.title = "Qualificação de Leads | Publicações Novas"

  const [loading, setLoading] = useState(false)
  const [selectedPublicacao, setSelectedPublicacao] = useState(null)

  const [filters, setFilters] = useState({
    Status: [StatusMap.Novo.value],
    Prioridade: ["1"],
    Data: "todasdatas",
  })
  const [showModal, setShowModal] = useState(false)
  const [inputs, setInputs] = useState([{ number: "", observations: "" }])
  const [isValidInputs, setIsValidInputs] = useState(inputs.map(() => false))
  const [tooltipOpen, setTooltipOpen] = useState(false)
  const [startPanel, setStartPanel] = useState(true)
  const [pageIndex, setPageIndex] = useState(1)
  const [pageSize, setPageSize] = useState(10)

  const dispatch = useDispatch()

  const toggleModal = () => {
    setShowModal(!showModal)
    setInputs([{ number: "", observations: "" }])
    setIsValidInputs(inputs.map(() => false))
    dispatch(resetProccessMessages())
  }

  const { publicacoes, totalCount, totalPages, currentPageIndex } = useSelector(
    state => state.Publicacao
  )

  // useEffect(() => {
  //     localStorage.setItem("pendingFilter", JSON.stringify(filters));
  //     if (publicacoes && !publicacoes.length) {
  //         dispatch(onGetPublicacoesPendentes({ filtros: filters, page: 1, pageSize: 10 }));
  //     }
  //     setLoading(false);
  // }, [dispatch]);

  useEffect(() => {
    setLoading(false)

    if (publicacoes && publicacoes.length) {
      setLoading(false)
      const pendingIds = publicacoes
        .map(d => d.Processo && d.Processo.Id)
        .filter(id => id)
      localStorage.setItem("pendingIds", JSON.stringify(pendingIds))
    } else {
      setLoading(false)
    }
  }, [publicacoes])

  //delete Job
  const [deleteModal, setDeleteModal] = useState(false)

  const onClickDelete = publicac => {
    setSelectedPublicacao(publicac)
    setDeleteModal(true)
  }

  var node = useRef()
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page)
    }
  }

  const handleDeletePublicacao = () => {
    if (selectedPublicacao.Id) {
      const deletedPublicacao = {
        Id: selectedPublicacao.Id,
        LeadAnalisado: new Date().toISOString().slice(0, 19).replace("T", " "),
        Status: StatusMap.Excluido.value,
      }
      dispatch(onUpdatePublicacao(deletedPublicacao))

      const pendingFilters = JSON.parse(localStorage.getItem("pendingFilter"))

      dispatch(
        onGetPublicacoesPendentes({
          filtros: pendingFilters,
          page: currentPageIndex,
          pageSize: pageSize,
        })
      )
      onPaginationPageChange(1)
      setDeleteModal(false)
    }
  }

  const [confirmModal, setConfirmModal] = useState(false)
  const [customConfirmModal, setCustomConfirmModal] = useState({
    Evento: "",
    Message: "",
  })
  const handleConfirmModal = async () => {
    if (customConfirmModal.Evento == "EnviarLead") {
      await sendPottencialLead()
    }
  }

  const [cargaModal, setCargaModal] = useState(false)

  const handleCargaModal = async () => {}

  const [editLoteModal, setEditLoteModal] = useState(false)
  const handleEditLoteModal = async () => {}

  const handleSetLeadOnList = (event, publicac) => {
    const updatedPublicacao = {
      Id: publicac.Id,
      LeadAnalisado: new Date().toISOString().slice(0, 19).replace("T", " "),
      Status: StatusMap.Incompleto.value,
    }

    const updatedProcesso = {
      Id: publicac.Processo.Id,
      IsLead: event.target.value,
    }

    dispatch(onUpdatePublicacao(updatedPublicacao))
    dispatch(onUpdateProcesso(updatedProcesso))

    onPaginationPageChange(1)
    // setDeleteModal(false);
  }

  const handleJobClicks = () => {
    //setJobsList("");
  }

  const handlePesquisarClick = filters => {
    setLoading(true)
    setStartPanel(false)
    localStorage.setItem("pendingFilter", JSON.stringify(filters))
    dispatch(
      onGetPublicacoesPendentes({
        filtros: filters,
        page: currentPageIndex,
        pageSize: pageSize,
      })
    )
  }

  function showToast(message, toastType, title) {
    // let toastType = "success";
    // const title = document.getElementById("title").value;
    // let message = "Have fun storming the castle!";

    toastr.options = {
      //   positionClass: positionClass,
      //   timeOut: timeOut,
      //   extendedTimeOut: extendedTimeOut,
      //   closeButton: closeButton,
      //   debug: debug,
      //   progressBar: progressBar,
      //   preventDuplicates: preventDuplicates,
      //   newestOnTop: newestOnTop,
      //   showEasing: showEasing,
      //   hideEasing: hideEasing,
      //   showMethod: showMethod,
      //   hideMethod: hideMethod,
      //   showDuration: showDuration,
      //   hideDuration: hideDuration
    }

    // setTimeout(() => toastr.success(`Settings updated `), 300)
    //Toaster Types
    if (toastType === "info") toastr.info(message, title)
    else if (toastType === "warning") toastr.warning(message, title)
    else if (toastType === "error") toastr.error(message, title)
    else toastr.success(message, title)
  }

  const columns = useMemo(
    () => [
      {
        Header: "#",
        disableFilters: true,
        filterable: false,
        Cell: ({ row: { original } }) => {
          // console.log("ORIGINAL_Filters", original)

          return (
            <ul className="list-unstyled hstack gap-1 mb-0">
              <li>
                <div>
                  <input
                    type="checkbox"
                    id={"checkSelected_" + original.Id}
                    className="form-check-input"
                  />
                </div>
              </li>
              <li
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Analisar"
              >
                <Link
                  to="#"
                  onClick={() => {
                    window.open(
                      "/qualificacao-detail/" + original.Processo.Id,
                      "_blank"
                    )
                  }}
                  //to={"/qualificacao-detail/" + original.Id_Processo}
                  className="btn btn-sm btn-soft-primary"
                >
                  <i className="mdi mdi-eye-outline" id="viewtooltip"></i>
                </Link>
              </li>
              <li
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Delete"
              >
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-danger"
                  onClick={() => {
                    const publicData = original
                    onClickDelete(publicData)
                  }}
                >
                  <i className="mdi mdi-delete-outline" id="deletetooltip" />
                </Link>
              </li>
              <li>
                <PublicNo {...original} />
              </li>
            </ul>
          )
        },
      },
      {
        Header: "É Lead?",
        accessor: "Processo",
        filterable: false,
        Cell: ({ row: { original } }) => {
          return (
            <div className="btn-group" role="group">
              <input
                type="radio"
                className="btn-check"
                defaultChecked={
                  original?.Processo?.IsLead != null &&
                  original?.Processo?.IsLead == true
                    ? true
                    : false
                }
                name={`btnradio-${original?.Processo?.Id}`}
                id={`btnradio-true-${original?.Processo?.Id}`}
                value={true}
                onChange={e => handleSetLeadOnList(e, original)}
              />
              <label
                className="btn btn-outline-primary"
                htmlFor={`btnradio-true-${original?.Processo?.Id}`}
              >
                <i className="fas fa-check label-icon"></i>{" "}
              </label>
              <input
                type="radio"
                className="btn-check"
                defaultChecked={
                  original?.Processo?.IsLead != null &&
                  original?.Processo?.IsLead == false
                    ? true
                    : false
                }
                name={`btnradio-${original?.Processo?.Id}`}
                id={`btnradio-false-${original?.Processo?.Id}`}
                value={false}
                onChange={e => handleSetLeadOnList(e, original)}
              />
              <label
                className="btn btn-outline-danger"
                htmlFor={`btnradio-false-${original?.Processo?.Id}`}
              >
                <i className="fas fa-times label-icon"></i>{" "}
              </label>
            </div>
          )
        },
      },
      // {
      //     Header: 'Tags',
      //     accessor: 'Tags',
      //     filterable: true,
      //     Cell: (cellProps) => {
      //         return <PublicTags {...cellProps} />;
      //     }
      // },
      // {
      //     Header: 'Polo Passivo',
      //     accessor: 'PoloPassivo',
      //     filterable: true,
      //     Cell: (cellProps) => {
      //         return <PoloPassivo {...cellProps} />;
      //     }
      // },
      // {
      //     Header: 'Valor',
      //     accessor: 'Valor',
      //     filterable: true,
      //     Cell: (cellProps) => {
      //         return <PublicValor {...cellProps} />;
      //     }
      // },
      {
        Header: "Data do Alerta",
        accessor: "DataPublicacao",
        Cell: cellProps => {
          return <PublicDate {...cellProps} />
        },
      },
      {
        Header: "Processo",
        accessor: "Processo.NumeroCNJ",
        Cell: cellProps => {
          return cellProps.value
        },
      },
      // {
      //     Header: 'Empresa Monitorada',
      //     accessor: 'Cliente',
      //     Cell: (cellProps) => {
      //         return cellProps.value;
      //     }
      // },
      {
        Header: "Prioridade",
        accessor: "Prioridade",
        Cell: cellProps => {
          return <Prioridade {...cellProps} />
        },
      },
      {
        Header: "Status",
        accessor: "Status",
        Cell: cellProps => {
          return <PublicStatus {...cellProps} />
        },
      },
      // {
      //     Header: 'Status do Lead',
      //     accessor: 'Processo.Lead.Status',
      //     Cell: (cellProps) => {
      //         return <LeadStatus {...cellProps} />;
      //     }
      // },
    ],
    []
  )

  return (
    <React.Fragment>
      {/* <ConfigApp/> */}
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeletePublicacao}
        onCloseClick={() => setDeleteModal(false)}
      />
      <ConfirmModal
        message={customConfirmModal.Message}
        show={confirmModal}
        onConfirmClick={handleConfirmModal}
        onCloseClick={() => setConfirmModal(false)}
      />
      <EditLoteModal
        show={editLoteModal}
        onCloseClick={() => setEditLoteModal(false)}
      />
      <CargaModal show={cargaModal} onCloseClick={() => setCargaModal(false)} />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Processamento" breadcrumbItem="Qualificação" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5 className="mb-0 card-title flex-grow-1">
                      Publicações Novas
                    </h5>
                    <div className="d-flex align-items-center">
                      <button
                        id="addProcessButton"
                        className="btn btn-primary me-1"
                        onClick={toggleModal}
                      >
                        <i className="mdi mdi-plus"></i>
                      </button>
                      <Tooltip
                        target="addProcessButton"
                        placement={"bottom"}
                        isOpen={tooltipOpen}
                        toggle={() => setTooltipOpen(!tooltipOpen)}
                      >
                        Adicionar processo
                      </Tooltip>

                      <Link to="#" className="btn btn-light me-1">
                        <i className="mdi mdi-refresh"></i>
                      </Link>
                      <UncontrolledDropdown className="dropdown d-inline-block me-1">
                        <DropdownToggle
                          type="menu"
                          className="btn btn-success"
                          id="dropdownMenuButton1"
                        >
                          <i className="mdi mdi-dots-vertical"></i>
                        </DropdownToggle>
                        <DropdownMenu>
                          <li>
                            <DropdownItem
                              onClick={() => setEditLoteModal(true)}
                            >
                              Editar em lote
                            </DropdownItem>
                          </li>
                          <li>
                            <DropdownItem onClick={() => setCargaModal(true)}>
                              Carga em lote
                            </DropdownItem>
                          </li>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </div>
                  </div>
                </CardBody>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={publicacoes}
                    isGlobalFilter={true}
                    handleJobClicks={handleJobClicks}
                    handleQualificacaoClick={handlePesquisarClick}
                    loading={loading}
                    setLoading={setLoading}
                    selectedFilters={filters}
                    setFilters={setFilters}
                    isJobListGlobalFilter={true}
                    customPageSize={10}
                    className="table table-hover"
                    startPanel={startPanel}
                    setStartPanel={setStartPanel}
                    setPageSizeClick={setPageSize}
                  />
                </CardBody>
                {/* TO-DO */}
                {/* <CardBody>
                                    <TableGrid/>
                                </CardBody> */}
              </Card>
              <ModalAddProcesso
                toggleModal={toggleModal}
                showModal={showModal}
                inputs={inputs}
                setInputs={setInputs}
                isValidInputs={isValidInputs}
                setIsValidInputs={setIsValidInputs}
              />
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default QualificacaoList
